<template>
  <div class="detail">
    <div class="detail__header">
      <div class="detail__header__title-wrapper">
        <div class="detail__header__title">
          Sigfox Coverage
        </div>
      </div>
    </div>
    <div class="detail__settings">
      <div class="detail__settings__wrapper">
        <CoverageMap/>
      </div>
    </div>
  </div>
</template>
<script>
  import CoverageMap from '@/views/sigfox-coverage/CoverageMap.vue';

  export default {
    name: 'SigfoxCoverage',
    components: {
      CoverageMap,
    },
    computed: {
    },
    methods: {
    },
  };
</script>
<style lang="scss" scoped>
  .detail {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 4rem;
    @media only screen and (max-width: 1199px) {
      width: 100%;
      grid-template-columns: 1fr;
      padding-bottom: 5em;
    }

    &__header {
      grid-column: 1/4;
      @media only screen and (max-width: 1199px) {
        grid-column: 1/1;
      }

      &__title-wrapper {
        margin: 18px 11rem;

        .placeholder {
          color: rgba(172, 180, 197, 0.26)
        }
      }

      &__title {
        font-weight: 700;
        font-size: 2.2rem;
        color: $dark;
        word-wrap: break-word;
        max-width: 55vw;
        @media only screen and (min-width: 1199px) {
          max-width: 25vw;
        }
      }
    }

    &__settings {
      grid-column: 1/2;
      @media only screen and (max-width: 1199px) {
        margin-top: 2em;
        width: 100%;
        grid-column: 1/2;
      }
    }
  }

</style>
